import Vue from "vue";

export default {
  state: {
    downloadData: {},
    downloadDataLoaded: false
  },
  mutations: {
    SET_DOWNLOAD_DATA(state, data) {
      state.downloadData = data;
    },
    SET_DOWNLOAD_DATA_LOADED(state) {
      state.downloadDataLoaded = true;
    }
  },
  actions: {
    async fetchDownloadData(context) {
      const {data} = await Vue.axios.get('/download/info');
      if (data.result) {
        context.commit('SET_DOWNLOAD_DATA', data.message);
        context.commit('SET_DOWNLOAD_DATA_LOADED');
      }
    },

    requestRpiImage(context, {releaseType, ssid, password}) {
      return Vue.axios.post('/softwareapi/getRaspberryImage', {
        'release_type': releaseType,
        'wifi_ssid': ssid,
        'wifi_password': password
      });
    }
  },
  getters: {
    downloadData: state => {
      return state.downloadData;
    },
    isDownloadDataLoaded: state => {
      return state.downloadDataLoaded;
    }
  }
}
